export const HOME = {
  UPDATE_FIELD: "UPDATE_FIELD",
  SET_STUDENT_PREFERENCE: "SET_STUDENT_PREFERENCE",
  GET_FILE_STATUS: "GET_FILE_STATUS",
};
